<span *ngIf="str">{{ str }}</span>
<ng-container *ngTemplateOutlet="ref"></ng-container>
